import React, { useState } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { patch } from '../../../services/apiController';
import { toast } from 'react-toastify';
import moment from 'moment';

const PreClosureModal = ({ open, onClose, agreementId, callback }) => {
  const [preClosureReason, setPreClosureReason] = useState('');
  const [preClosureApprovedBy, setPreClosureApprovedBy] = useState('');
  const [preClosureDate, setPreClosureDate] = useState(moment().format('YYYY-MM-DD'));
  const [loading, setLoading] = useState(false);

  const handlePreClose = () => {
    if (!preClosureReason.trim()) {
      toast.error('Please provide a reason for pre-closure');
      return;
    }

    if (!preClosureApprovedBy.trim()) {
      toast.error('Please provide the name of the person who approved the pre-closure');
      return;
    }

    if (!preClosureDate) {
      toast.error('Please select a pre-closure date');
      return;
    }

    // Validate that preClosureDate is not a future date
    if (moment(preClosureDate).isAfter(moment(), 'day')) {
      toast.error('Pre-closure date cannot be a future date');
      return;
    }

    setLoading(true);
    patch(
      { 
        preClosureReason, 
        preClosureApprovedBy, 
        preClosureDate 
      }, 
      `/agreements/pre-close/${agreementId}`
    )
      .then((res) => {
        toast.success(res.data.message);
        onClose();
        callback();
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={open} onHide={onClose} backdrop="static" keyboard={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Pre-Close Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-danger mb-3">
          Warning: This action will pre-close the agreement and prevent any further editing of the agreement details.
        </p>
        <Row>
          <Col md={8}>
            <Form.Group className="mb-3">
              <Form.Label>Approved By <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={preClosureApprovedBy}
                onChange={(e) => setPreClosureApprovedBy(e.target.value)}
                placeholder="Enter name of person who approved the pre-closure"
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Pre-Closure Date <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="date"
                value={preClosureDate}
                onChange={(e) => setPreClosureDate(e.target.value)}
                max={moment().format('YYYY-MM-DD')}
                required
              />
              <small className="text-muted">Cannot be a future date</small>
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Label>Reason for Pre-Closure <span className="text-danger">*</span></Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={preClosureReason}
            onChange={(e) => setPreClosureReason(e.target.value)}
            placeholder="Enter detailed reason for pre-closing this agreement"
            required
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn app-btn-default" onClick={onClose} disabled={loading}>
          Cancel
        </button>
        <button className="btn app-btn-danger" onClick={handlePreClose} disabled={loading}>
          {loading ? 'Pre-Closing...' : 'Pre-Close Agreement'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreClosureModal;
